import * as Moment from "moment";

/**
 * 診断書WF用日付変換クラス
 * infrastructure配下にあって設計的におかしなことになっていたのでdomainに移動した経緯あり
 * そもそもどの層で変換するべきかどうかの検討が足りていない気がする
 */
export class ReceptionDateTranslator {
  private readonly DATE_FORMAT = "YYYYMMDD";
  private readonly TIME_FORMAT = "HHmm00";
  private readonly DATETIME_FORMAT = "YYYYMMDDHHmmss";

  private readonly DATE_DISP_FORMAT = "YY/MM/DD";
  private readonly TIME_DISP_FORMAT = "HH:mm";
  private readonly DATETIME_DISP_FORMAT = "YY/MM/DD HH:mm";

  private readonly TIMESTAMP_FORMAT = "YY/MM/DD HH:mm:ss";

  // -- string to Date --

  fromDateString(source: string): Date {
    return this.toDate(source, this.DATE_FORMAT);
  }

  // From version 2.11.0 parsing hmm, Hmm, hmmss and Hmmss is supported:
  // moment("123", "hmm").format("HH:mm") === "01:23"
  // moment("1234", "hmm").format("HH:mm") === "12:34"

  fromTimeString(source: string): Date {
    return this.toDate(source, this.TIME_FORMAT);
  }

  fromDateTimeString(source: string): Date {
    return this.toDate(source, this.DATETIME_FORMAT);
  }

  private toDate(source: string, format: string): Date {
    if (!source) { return null; }
    return Moment(source, format).toDate();
  }

  // -- Date to string --

  toDateString(source: Date): string {
    return this.fromDate(source, this.DATE_FORMAT);
  }

  toTimeString(source: Date): string {
    return this.fromDate(source, this.TIME_FORMAT);
  }

  toDateTimeString(source: Date): string {
    return this.fromDate(source, this.DATETIME_FORMAT);
  }

  toDateDispString(source: Date): string {
    return this.fromDate(source, this.DATE_DISP_FORMAT);
  }

  toTimeDispString(source: Date): string {
    return this.fromDate(source, this.TIME_DISP_FORMAT);
  }

  toDateTimeDispString(source: Date): string {
    return this.fromDate(source, this.DATETIME_DISP_FORMAT);
  }

  toTimeStampString(source: Date): string {
    const dateStr = this.fromDate(source, this.TIMESTAMP_FORMAT);
    if (dateStr) {return dateStr + ":" +　("000" + source.getMilliseconds()).slice(-3); }

    return dateStr;
  }

  private fromDate(source: Date, format: string): string {
    if (!source) { return ""; }
    return Moment(source).format(format);
  }

  // 計算

  addDays(target: Date, days: number): Date {
    return Moment(target).add(days, "days").toDate();
  }

  durationDays(from: Date, to: Date): number {
    if (!from || !to) { return null; }

    const fromM = Moment(from);
    const toM = Moment(to);

    return toM.diff(fromM, "days");
  }
}
